module.exports = __webpack_public_path__ + "static/media/youtube.01e6be5f.svg";